/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_ButtonInputs */



/**
* | output |
* | --- |
* | "Merge Metadata" |
*
* @param {Metadata_Merge_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_button = /** @type {((inputs?: Metadata_Merge_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Combinar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータのマージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar metadados")
	return /** @type {LocalizedString} */ ("Merge Metadata")
});